import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import RoomCard from '../components/rooms/RoomCard';
import EmptyState from '../components/common/EmptyState';

const FLOORS = ['all', 'basement', '1st', '2nd', '3rd', 'attic'];

const Rooms = () => {
  const { rooms, fetchRooms, loading } = useApp();
  const [floorFilter, setFloorFilter] = useState('all');

  useEffect(() => { fetchRooms(); }, [fetchRooms]);

  const filtered = floorFilter === 'all'
    ? rooms
    : rooms.filter((r) => r.floor === floorFilter);

  const byFloor = FLOORS.slice(1).reduce((acc, floor) => {
    const floorRooms = filtered.filter((r) => r.floor === floor);
    if (floorRooms.length) acc[floor] = floorRooms;
    return acc;
  }, {});

  if (loading) return <div className="loading">Loading…</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h1>House Rooms</h1>
        <Link to="/rooms/new" className="btn btn-primary">+ Add Room</Link>
      </div>

      <div className="filter-bar">
        {FLOORS.map((f) => (
          <button
            key={f}
            className={`filter-btn${floorFilter === f ? ' active' : ''}`}
            onClick={() => setFloorFilter(f)}
          >
            {f === 'all' ? 'All Floors' : `${f} floor`}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <EmptyState
          icon="🚪"
          title="No rooms yet"
          message="Document each room's paint colors, flooring, outlets, and fixtures for easy reference."
          actionLabel="+ Add Room"
          actionTo="/rooms/new"
        />
      ) : floorFilter === 'all' ? (
        Object.entries(byFloor).map(([floor, floorRooms]) => (
          <section key={floor}>
            <h2>{floor.charAt(0).toUpperCase() + floor.slice(1)} Floor</h2>
            <div className="card-grid">
              {floorRooms.map((room) => (
                <RoomCard key={room._id} room={room} />
              ))}
            </div>
          </section>
        ))
      ) : (
        <div className="card-grid">
          {filtered.map((room) => (
            <RoomCard key={room._id} room={room} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Rooms;
